exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Button__button___aonc4 {\n  width: 100%;\n  height: 30px;\n  border-radius: 5px;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  line-height: 1.21;\n}\n.Button__button___aonc4:hover {\n  cursor: pointer;\n}\n\n.Button__icon___o4MRG {\n  width: 17px;\n  height: 17px;\n  margin-right: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"button": "Button__button___aonc4",
	"icon": "Button__icon___o4MRG"
};